







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AppTooltip extends Vue {
  @Prop({ required: true }) public readonly content!: string;
  @Prop({ default: false }) public show!: boolean;
  @Prop({ default: false }) public escaped!: boolean;
  @Prop({ default: '' }) public readonly extraClass!: string; // Additional class
}
